import { combineReducers } from 'redux';
import { ActionTypes } from '../constants';
import initialState from './initialState';

// exporting for testing
export function application(state = initialState.application, action) {
  switch (action.type) {
    case ActionTypes.SET_SSO_STAGE:
      return Object.assign({}, state, {
        ssoStage: action.payload.ssoStage,
      });
    case ActionTypes.SET_ERROR:
      return Object.assign({}, state, {
        error: action.payload.errorMessage,
      });
    default:
      return state;
  }
}

export default combineReducers({
  application,
});



// WEBPACK FOOTER //
// ./src/reducers/index.js